import { colors } from 'src/constants';
import { RMAFormField } from '../types';
import { RMAField, RMAFieldLabel } from './rma-fields';
import { PCWorthBranchesEnum } from 'src/enums/branches';

export const rmaDefaultValues = {
  defaultCustomerNameStockUnit: 'STOCK UNIT'
};

export const rmaStatuses = {
  RMA_STORE_INQUIRING: 'RMA STORE INQUIRING',
  RMA_STORE_PENDING: 'RMA STORE PENDING',
  RMA_STORE_FOR_CHECKING: 'RMA STORE FOR CHECKING',
  RMA_STORE_ONGOING_DIAGNOSIS: 'RMA STORE ONGOING DIAGNOSIS',
  RMA_STORE_REPORTED_TO_SERVICE_CENTER: 'RMA STORE REPORTED TO SERVICE CENTER',
  RMA_STORE_COMPLETED: 'RMA STORE COMPLETED',
  RMA_STORE_CLOSED_TICKET: 'RMA STORE CLOSED TICKET',
  RMA_STORE_FOR_PICKUP: 'RMA STORE FOR PICKUP',
  RMA_STORE_FOR_PICKUP_VOID: 'RMA STORE FOR PICKUP VOID',

  RMA_STORE_FOR_RETURN_TO_EU: 'RMA STORE FOR RETURN TO EU',
  RMA_STORE_REPLACED: 'RMA STORE REPLACED',
  RMA_STORE_REFUNDED: 'RMA STORE REFUNDED',
  RMA_STORE_VOIDED_WARRANTY: 'RMA STORE VOIDED WARRANTY',
  RMA_STORE_WARRANTY_EXPIRED: 'RMA STORE WARRANTY EXPIRED',
  RMA_STORE_ESCALATED_TO_MANAGEMENT: 'RMA STORE ESCALATED TO MANAGEMENT',
  RMA_STORE_ESCALATED_TO_SUPPLIER: 'RMA STORE ESCALATED TO SUPPLIER',
  RMA_STORE_ESCALATED_TO_VENDOR: 'RMA STORE ESCALATED TO VENDOR',

  // Service Center Statuses
  RMA_SC_PULL_OUT: 'RMA SC PULL OUT',
  RMA_SC_FOR_RETURN_GOOD: 'RMA SC FOR RETURN GOOD',
  RMA_SC_FOR_RETURN_VOID: 'RMA SC FOR RETURN VOID',
  RMA_SC_FOR_RETURN_REPAIRED: 'RMA SC FOR RETURN REPAIRED',
  RMA_SC_FOR_RETURN_REPLACED: 'RMA SC FOR RETURN REPLACED',
  RMA_SC_FOR_RETURN_REPLACED_SAME_UNIT: 'RMA SC FOR RETURN REPLACED SAME UNIT',
  RMA_SC_FOR_RETURN_REPLACED_OTHER_MODEL:
    'RMA SC FOR RETURN REPLACED OTHER MODEL',
  RMA_SC_FOR_CREDIT_MEMO: 'RMA SC CREDIT MEMO',
  RMA_SC_ONGOING_TESTING: 'RMA SC ONGOING TESTING',
  RMA_SC_LINE_UP_FOR_TESTING: 'RMA SC LINE UP FOR TESTING',
  RMA_SC_FOR_CHECKING: 'RMA SC FOR CHECKING',
  RMA_SC_FOR_REPORTING: 'RMA SC FOR REPORTING',
  RMA_SC_PROCESSING: 'RMA SC PROCESSING',
  RMA_SC_TESTED_GOOD: 'RMA SC TESTED GOOD',
  RMA_SC_PENDING: 'RMA SC PENDING',
  RMA_SC_TO_PC_WORTH: 'RMA SC TO PC WORTH',
  RMA_SC_VOIDED_WARRANTY: 'RMA SC VOIDED WARRANTY',
  RMA_SC_WARRANTY_EXPIRED: 'RMA SC WARRANTY EXPIRED',

  // General RMA Statuses
  RMA_LOST_ITEM: 'RMA LOST ITEM',
  RMA_DAMAGED_IN_TRANSIT: 'RMA DAMAGED IN TRANSIT',
  RMA_INCORRECT_ITEM_RECEIVED: 'RMA INCORRECT ITEM RECEIVED',
  RMA_EU_NO_RESPONSE: 'RMA EU NO RESPONSE',
  RMA_UNAUTHORIZED_RETURN: 'RMA UNAUTHORIZED RETURN'
};

export const rmaStatuesV2 = {
  //Online status
  ONLINE_PENDING: 'RMA ONLINE PENDING',
  ONLINE_FOR_VALIDATION: 'RMA ONLINE FOR VALIDATION',
  ONLINE_AWAITING_CUSTOMER_RESPONSE: 'RMA ONLINE AWAITING CUSTOMER RESPONSE',
  ONLINE_AWAITING_ITEM_SHIPMENT: 'RMA ONLINE AWAITING ITEM SHIPMENT',
  ONLINE_ITEM_IN_TRANSIT: 'RMA ONLINE ITEM IN TRANSIT TO STORE/SERVICE CENTER',
  ONLINE_ITEM_RECEIVED_AT_STORE: 'RMA ONLINE ITEM RECEIVED AT STORE',
  ONLINE_FIRST_DIAGNOSE: 'RMA ONLINE FIRST DIAGNOSE',
  ONLINE_TRANSFER_IN_HQ: 'RMA ONLINE TRANSFER IN HQ RMA',
  ONLINE_DEEPER_DIAGNOSE: 'RMA ONLINE DEEPER DIAGNOSE',
  ONLINE_REJECTED_CLAIM: 'RMA ONLINE REJECTED CLAIM',
  ONLINE_REJECTED_CLOSE_TICKET: 'RMA ONLINE REJECTED CLOSE TICKET',

  //Store status
  STORE_PENDING: 'RMA STORE PENDING',
  STORE_FOR_CHECKING: 'RMA STORE FOR CHECKING',
  STORE_DIAGNOSE: 'RMA STORE DIAGNOSE',
  STORE_DEEPER_DIAGNOSE: 'RMA STORE DEEPER DIAGNOSE',
  STORE_TRANSFER_IN_HQ: 'RMA STORE TRANSFER IN HQ RMA',
  STORE_CLOSED_TICKET: 'RMA STORE CLOSED TICKET',
  STORE_FOR_PICKUP: 'RMA STORE FOR PICKUP',
  STORE_FOR_RETURN_TO_USER: 'RMA STORE FOR RETURN TO END USER',
  STORE_REJECTED_CLAIM: 'RMA STORE REJECTED CLAIM',

  //RMA HQ
  HQ_RECEIVED_FROM_STORE: 'RMA HQ RECEIVED FROM STORE',
  HQ_RECEIVED_FROM_ONLINE: 'RMA HQ RECEIVED FROM ONLINE',
  HQ_FOR_VERIFICATION: 'RMA HQ FOR VERIFICATION',
  HQ_SECOND_LEVEL_DIAGNOSIS: 'RMA HQ SECOND-LEVEL DIAGNOSIS',
  HQ_REJECTED_CLAIM: 'RMA HQ REJECTED CLAIM',
  HQ_FOR_RETURN_TO_STORE: 'RMA HQ FOR RETURN TO STORE',
  HQ_FOR_RETURN_TO_ONLINE: 'RMA HQ FOR RETURN TO ONLINE',
  HQ_CLOSED_TICKET: 'RMA HQ CLOSED TICKET',
  HQ_STORE_REPORTED_TO_SC: 'RMA HQ STORE REPORTED TO SERVICE CENTER',
  HQ_SC_PULL_OUT: 'RMA HQ SC PULL OUT',

  //RMQ HQ and Service center
  IN_SERVICE_CENTER: 'RMA IN SERVICE CENTER',
  SC_FOR_RETURN_TESTED_GOOD: 'RMA SC FOR RETURN TESTED GOOD',
  SC_FOR_RETURN_REPLACED_SAME: 'RMA SC FOR RETURN REPLACED SAME UNIT',
  SC_FOR_RETURN_REPLACED_OTHER: 'RMA SC FOR RETURN REPLACED OTHER MODEL',
  SC_FOR_RETURN_VOID: 'RMA SC FOR RETURN VOID',
  SC_FOR_RETURN_REPAIRED: 'RMA SC FOR RETURN REPAIRED',
  SC_CREDIT_MEMO: 'RMA SC CREDIT MEMO'
};

export const allowedStatusThatRequiredBranch = [
  rmaStatuesV2.STORE_PENDING,
  rmaStatuesV2.STORE_FOR_CHECKING,
  rmaStatuesV2.STORE_DIAGNOSE,
  rmaStatuesV2.STORE_DEEPER_DIAGNOSE,
  rmaStatuesV2.STORE_TRANSFER_IN_HQ,
  rmaStatuesV2.STORE_FOR_PICKUP,
  rmaStatuesV2.STORE_FOR_RETURN_TO_USER
];

export const statusesThatRequiredChangeListing = [
  rmaStatuesV2.SC_FOR_RETURN_REPLACED_SAME,
  rmaStatuesV2.SC_FOR_RETURN_REPLACED_OTHER
];

export const rmaStatusValidPermission = {
  ONLINE: 'can_view_rma_online_status',
  STORE: 'can_view_rma_store_status',
  RMA_HQ: 'can_view_rma_hq_status',
  RMA_SC: 'can_view_rma_sc_status'
};

export const rmaOptionsStatuses = [
  // Store Statuses
  {
    key: rmaStatuses.RMA_STORE_INQUIRING,
    label: rmaStatuses.RMA_STORE_INQUIRING,
    value: rmaStatuses.RMA_STORE_INQUIRING,
    bgColor: colors.lightBlue[600],
    deprecated: true,
    disabled: true,
    allowed_permission: []
  },
  {
    key: rmaStatuses.RMA_STORE_PENDING,
    label: rmaStatuses.RMA_STORE_PENDING,
    value: rmaStatuses.RMA_STORE_PENDING,
    bgColor: colors.grey[600],
    deprecated: true,
    disabled: true,
    allowed_permission: []
  },
  {
    key: rmaStatuses.RMA_STORE_FOR_CHECKING,
    label: rmaStatuses.RMA_STORE_FOR_CHECKING,
    value: rmaStatuses.RMA_STORE_FOR_CHECKING,
    bgColor: colors.orange[600],
    deprecated: true,
    disabled: true,
    allowed_permission: []
  },
  {
    key: rmaStatuses.RMA_STORE_ONGOING_DIAGNOSIS,
    label: rmaStatuses.RMA_STORE_ONGOING_DIAGNOSIS,
    value: rmaStatuses.RMA_STORE_ONGOING_DIAGNOSIS,
    bgColor: colors.lime[600],
    deprecated: true,
    disabled: true,
    allowed_permission: []
  },
  {
    key: rmaStatuses.RMA_STORE_REPORTED_TO_SERVICE_CENTER,
    label: rmaStatuses.RMA_STORE_REPORTED_TO_SERVICE_CENTER,
    value: rmaStatuses.RMA_STORE_REPORTED_TO_SERVICE_CENTER,
    bgColor: colors.blueGrey[600],
    deprecated: true,
    disabled: true,
    allowed_permission: []
  },
  {
    key: rmaStatuses.RMA_STORE_COMPLETED,
    label: rmaStatuses.RMA_STORE_COMPLETED,
    value: rmaStatuses.RMA_STORE_COMPLETED,
    bgColor: colors.green[600],
    deprecated: true,
    disabled: true,
    allowed_permission: []
  },
  {
    key: rmaStatuses.RMA_STORE_CLOSED_TICKET,
    label: rmaStatuses.RMA_STORE_CLOSED_TICKET,
    value: rmaStatuses.RMA_STORE_CLOSED_TICKET,
    bgColor: colors.teal[600],
    deprecated: true,
    disabled: true,
    allowed_permission: []
  },
  {
    key: rmaStatuses.RMA_STORE_FOR_PICKUP,
    label: rmaStatuses.RMA_STORE_FOR_PICKUP,
    value: rmaStatuses.RMA_STORE_FOR_PICKUP,
    bgColor: colors.purple[600],
    deprecated: true,
    disabled: true,
    allowed_permission: []
  },
  {
    key: rmaStatuses.RMA_STORE_FOR_PICKUP_VOID,
    label: rmaStatuses.RMA_STORE_FOR_PICKUP_VOID,
    value: rmaStatuses.RMA_STORE_FOR_PICKUP_VOID,
    bgColor: colors.red[600],
    deprecated: true,
    disabled: true,
    allowed_permission: []
  }
];

export const rmaOptionsStatusesV2 = [
  // Online Statuses
  {
    key: rmaStatuesV2.ONLINE_PENDING,
    label: rmaStatuesV2.ONLINE_PENDING,
    value: rmaStatuesV2.ONLINE_PENDING,
    bgColor: colors.grey[600],
    deprecated: false,
    disabled: false,
    allowed_permission: [rmaStatusValidPermission.ONLINE]
  },
  {
    key: rmaStatuesV2.ONLINE_FOR_VALIDATION,
    label: rmaStatuesV2.ONLINE_FOR_VALIDATION,
    value: rmaStatuesV2.ONLINE_FOR_VALIDATION,
    bgColor: colors.orange[600],
    deprecated: false,
    disabled: false,
    allowed_permission: [rmaStatusValidPermission.ONLINE]
  },
  {
    key: rmaStatuesV2.ONLINE_AWAITING_CUSTOMER_RESPONSE,
    label: rmaStatuesV2.ONLINE_AWAITING_CUSTOMER_RESPONSE,
    value: rmaStatuesV2.ONLINE_AWAITING_CUSTOMER_RESPONSE,
    bgColor: colors.blue[600],
    deprecated: false,
    disabled: false,
    allowed_permission: [rmaStatusValidPermission.ONLINE]
  },
  {
    key: rmaStatuesV2.ONLINE_AWAITING_ITEM_SHIPMENT,
    label: rmaStatuesV2.ONLINE_AWAITING_ITEM_SHIPMENT,
    value: rmaStatuesV2.ONLINE_AWAITING_ITEM_SHIPMENT,
    bgColor: colors.indigo[600],
    deprecated: false,
    disabled: false,
    allowed_permission: [rmaStatusValidPermission.ONLINE]
  },
  {
    key: rmaStatuesV2.ONLINE_ITEM_IN_TRANSIT,
    label: rmaStatuesV2.ONLINE_ITEM_IN_TRANSIT,
    value: rmaStatuesV2.ONLINE_ITEM_IN_TRANSIT,
    bgColor: colors.lightBlue[600],
    deprecated: false,
    disabled: false,
    allowed_permission: [rmaStatusValidPermission.ONLINE]
  },
  {
    key: rmaStatuesV2.ONLINE_ITEM_RECEIVED_AT_STORE,
    label: rmaStatuesV2.ONLINE_ITEM_RECEIVED_AT_STORE,
    value: rmaStatuesV2.ONLINE_ITEM_RECEIVED_AT_STORE,
    bgColor: colors.green[600],
    deprecated: false,
    disabled: false,
    allowed_permission: [rmaStatusValidPermission.ONLINE]
  },
  {
    key: rmaStatuesV2.ONLINE_FIRST_DIAGNOSE,
    label: rmaStatuesV2.ONLINE_FIRST_DIAGNOSE,
    value: rmaStatuesV2.ONLINE_FIRST_DIAGNOSE,
    bgColor: colors.lime[600],
    deprecated: false,
    disabled: false,
    allowed_permission: [rmaStatusValidPermission.ONLINE]
  },
  {
    key: rmaStatuesV2.ONLINE_TRANSFER_IN_HQ,
    label: rmaStatuesV2.ONLINE_TRANSFER_IN_HQ,
    value: rmaStatuesV2.ONLINE_TRANSFER_IN_HQ,
    bgColor: colors.teal[600],
    deprecated: false,
    disabled: false,
    allowed_permission: [rmaStatusValidPermission.ONLINE]
  },
  {
    key: rmaStatuesV2.ONLINE_DEEPER_DIAGNOSE,
    label: rmaStatuesV2.ONLINE_DEEPER_DIAGNOSE,
    value: rmaStatuesV2.ONLINE_DEEPER_DIAGNOSE,
    bgColor: colors.deepPurple[600],
    deprecated: false,
    disabled: false,
    allowed_permission: [rmaStatusValidPermission.ONLINE]
  },
  {
    key: rmaStatuesV2.ONLINE_REJECTED_CLAIM,
    label: rmaStatuesV2.ONLINE_REJECTED_CLAIM,
    value: rmaStatuesV2.ONLINE_REJECTED_CLAIM,
    bgColor: colors.red[600],
    deprecated: false,
    disabled: false,
    allowed_permission: [rmaStatusValidPermission.ONLINE]
  },
  {
    key: rmaStatuesV2.ONLINE_REJECTED_CLOSE_TICKET,
    label: rmaStatuesV2.ONLINE_REJECTED_CLOSE_TICKET,
    value: rmaStatuesV2.ONLINE_REJECTED_CLOSE_TICKET,
    bgColor: colors.red[800],
    deprecated: false,
    disabled: false,
    allowed_permission: [rmaStatusValidPermission.ONLINE]
  },

  // Store Statuses
  {
    key: rmaStatuesV2.STORE_PENDING,
    label: rmaStatuesV2.STORE_PENDING,
    value: rmaStatuesV2.STORE_PENDING,
    bgColor: colors.grey[600],
    deprecated: false,
    disabled: false,
    allowed_permission: [rmaStatusValidPermission.STORE]
  },
  {
    key: rmaStatuesV2.STORE_FOR_CHECKING,
    label: rmaStatuesV2.STORE_FOR_CHECKING,
    value: rmaStatuesV2.STORE_FOR_CHECKING,
    bgColor: colors.orange[600],
    deprecated: false,
    disabled: false,
    allowed_permission: [rmaStatusValidPermission.STORE]
  },
  {
    key: rmaStatuesV2.STORE_DIAGNOSE,
    label: rmaStatuesV2.STORE_DIAGNOSE,
    value: rmaStatuesV2.STORE_DIAGNOSE,
    bgColor: colors.lime[600],
    deprecated: false,
    disabled: false,
    allowed_permission: [rmaStatusValidPermission.STORE]
  },
  {
    key: rmaStatuesV2.STORE_DEEPER_DIAGNOSE,
    label: rmaStatuesV2.STORE_DEEPER_DIAGNOSE,
    value: rmaStatuesV2.STORE_DEEPER_DIAGNOSE,
    bgColor: colors.indigo[600],
    deprecated: false,
    disabled: false,
    allowed_permission: [rmaStatusValidPermission.STORE]
  },
  {
    key: rmaStatuesV2.STORE_TRANSFER_IN_HQ,
    label: rmaStatuesV2.STORE_TRANSFER_IN_HQ,
    value: rmaStatuesV2.STORE_TRANSFER_IN_HQ,
    bgColor: colors.blueGrey[600],
    deprecated: false,
    disabled: false,
    allowed_permission: [rmaStatusValidPermission.STORE]
  },
  {
    key: rmaStatuesV2.STORE_CLOSED_TICKET,
    label: rmaStatuesV2.STORE_CLOSED_TICKET,
    value: rmaStatuesV2.STORE_CLOSED_TICKET,
    bgColor: colors.teal[600],
    deprecated: false,
    disabled: false,
    allowed_permission: [rmaStatusValidPermission.STORE]
  },
  {
    key: rmaStatuesV2.STORE_FOR_PICKUP,
    label: rmaStatuesV2.STORE_FOR_PICKUP,
    value: rmaStatuesV2.STORE_FOR_PICKUP,
    bgColor: colors.purple[600],
    deprecated: false,
    disabled: false,
    allowed_permission: [rmaStatusValidPermission.STORE]
  },
  {
    key: rmaStatuesV2.STORE_FOR_RETURN_TO_USER,
    label: rmaStatuesV2.STORE_FOR_RETURN_TO_USER,
    value: rmaStatuesV2.STORE_FOR_RETURN_TO_USER,
    bgColor: colors.cyan[600],
    deprecated: false,
    disabled: false,
    allowed_permission: [rmaStatusValidPermission.STORE]
  },
  {
    key: rmaStatuesV2.STORE_REJECTED_CLAIM,
    label: rmaStatuesV2.STORE_REJECTED_CLAIM,
    value: rmaStatuesV2.STORE_REJECTED_CLAIM,
    bgColor: colors.red[600],
    deprecated: false,
    disabled: false,
    allowed_permission: [rmaStatusValidPermission.STORE]
  },

  // HQ Statuses
  {
    key: rmaStatuesV2.HQ_RECEIVED_FROM_STORE,
    label: rmaStatuesV2.HQ_RECEIVED_FROM_STORE,
    value: rmaStatuesV2.HQ_RECEIVED_FROM_STORE,
    bgColor: colors.lightBlue[600],
    allowed_permission: [rmaStatusValidPermission.RMA_HQ]
  },
  {
    key: rmaStatuesV2.HQ_RECEIVED_FROM_ONLINE,
    label: rmaStatuesV2.HQ_RECEIVED_FROM_ONLINE,
    value: rmaStatuesV2.HQ_RECEIVED_FROM_ONLINE,
    bgColor: colors.lightBlue[800],
    allowed_permission: [rmaStatusValidPermission.RMA_HQ]
  },
  {
    key: rmaStatuesV2.HQ_FOR_VERIFICATION,
    label: rmaStatuesV2.HQ_FOR_VERIFICATION,
    value: rmaStatuesV2.HQ_FOR_VERIFICATION,
    bgColor: colors.orange[600],
    allowed_permission: [rmaStatusValidPermission.RMA_HQ]
  },
  {
    key: rmaStatuesV2.HQ_SECOND_LEVEL_DIAGNOSIS,
    label: rmaStatuesV2.HQ_SECOND_LEVEL_DIAGNOSIS,
    value: rmaStatuesV2.HQ_SECOND_LEVEL_DIAGNOSIS,
    bgColor: colors.indigo[600],
    allowed_permission: [rmaStatusValidPermission.RMA_HQ]
  },
  {
    key: rmaStatuesV2.HQ_REJECTED_CLAIM,
    label: rmaStatuesV2.HQ_REJECTED_CLAIM,
    value: rmaStatuesV2.HQ_REJECTED_CLAIM,
    bgColor: colors.red[600],
    allowed_permission: [rmaStatusValidPermission.RMA_HQ]
  },
  {
    key: rmaStatuesV2.HQ_FOR_RETURN_TO_STORE,
    label: rmaStatuesV2.HQ_FOR_RETURN_TO_STORE,
    value: rmaStatuesV2.HQ_FOR_RETURN_TO_STORE,
    bgColor: colors.blueGrey[600],
    allowed_permission: [rmaStatusValidPermission.RMA_HQ]
  },
  {
    key: rmaStatuesV2.HQ_FOR_RETURN_TO_ONLINE,
    label: rmaStatuesV2.HQ_FOR_RETURN_TO_ONLINE,
    value: rmaStatuesV2.HQ_FOR_RETURN_TO_ONLINE,
    bgColor: colors.blueGrey[800],
    allowed_permission: [rmaStatusValidPermission.RMA_HQ]
  },
  {
    key: rmaStatuesV2.HQ_CLOSED_TICKET,
    label: rmaStatuesV2.HQ_CLOSED_TICKET,
    value: rmaStatuesV2.HQ_CLOSED_TICKET,
    bgColor: colors.teal[600],
    allowed_permission: [rmaStatusValidPermission.RMA_HQ]
  },
  {
    key: rmaStatuesV2.HQ_STORE_REPORTED_TO_SC,
    label: rmaStatuesV2.HQ_STORE_REPORTED_TO_SC,
    value: rmaStatuesV2.HQ_STORE_REPORTED_TO_SC,
    bgColor: colors.deepOrange[600],
    allowed_permission: [rmaStatusValidPermission.RMA_HQ]
  },
  {
    key: rmaStatuesV2.HQ_SC_PULL_OUT,
    label: rmaStatuesV2.HQ_SC_PULL_OUT,
    value: rmaStatuesV2.HQ_SC_PULL_OUT,
    bgColor: colors.orange[600],
    allowed_permission: [rmaStatusValidPermission.RMA_HQ]
  },

  // Service Center Statuses
  {
    key: rmaStatuesV2.IN_SERVICE_CENTER,
    label: rmaStatuesV2.IN_SERVICE_CENTER,
    value: rmaStatuesV2.IN_SERVICE_CENTER,
    bgColor: colors.lime[600],
    allowed_permission: [rmaStatusValidPermission.RMA_SC]
  },
  {
    key: rmaStatuesV2.SC_FOR_RETURN_TESTED_GOOD,
    label: rmaStatuesV2.SC_FOR_RETURN_TESTED_GOOD,
    value: rmaStatuesV2.SC_FOR_RETURN_TESTED_GOOD,
    bgColor: colors.green[600],
    allowed_permission: [rmaStatusValidPermission.RMA_SC]
  },
  {
    key: rmaStatuesV2.SC_FOR_RETURN_REPLACED_SAME,
    label: rmaStatuesV2.SC_FOR_RETURN_REPLACED_SAME,
    value: rmaStatuesV2.SC_FOR_RETURN_REPLACED_SAME,
    bgColor: colors.cyan[600],
    allowed_permission: [rmaStatusValidPermission.RMA_SC]
  },
  {
    key: rmaStatuesV2.SC_FOR_RETURN_REPLACED_OTHER,
    label: rmaStatuesV2.SC_FOR_RETURN_REPLACED_OTHER,
    value: rmaStatuesV2.SC_FOR_RETURN_REPLACED_OTHER,
    bgColor: colors.cyan[400],
    allowed_permission: [rmaStatusValidPermission.RMA_SC]
  },
  {
    key: rmaStatuesV2.SC_FOR_RETURN_VOID,
    label: rmaStatuesV2.SC_FOR_RETURN_VOID,
    value: rmaStatuesV2.SC_FOR_RETURN_VOID,
    bgColor: colors.red[600],
    allowed_permission: [rmaStatusValidPermission.RMA_SC]
  },
  {
    key: rmaStatuesV2.SC_FOR_RETURN_REPAIRED,
    label: rmaStatuesV2.SC_FOR_RETURN_REPAIRED,
    value: rmaStatuesV2.SC_FOR_RETURN_REPAIRED,
    bgColor: colors.blue[600],
    allowed_permission: [rmaStatusValidPermission.RMA_SC]
  },
  {
    key: rmaStatuesV2.SC_CREDIT_MEMO,
    label: rmaStatuesV2.SC_CREDIT_MEMO,
    value: rmaStatuesV2.SC_CREDIT_MEMO,
    bgColor: colors.purple[600],
    allowed_permission: [rmaStatusValidPermission.RMA_SC]
  }
];

export const rmaLocations = {
  EARNSHAW: 'EARNSHAW',
  LPC: 'LPC',
  EXPERIENCE: 'EXPERIENCE',
  EU: 'EU',
  SERVICE_CENTER: 'SERVICE CENTER'
};

export type RmaLocation = {
  key: string;
  label: string;
  value: string;
  branch_id?: number;
};

export const rmaLocationOptionsV2: RmaLocation[] = [
  {
    key: 'end user',
    label: 'END USER',
    value: 'END USER'
  },
  {
    key: 'store',
    label: 'STORE',
    value: 'STORE'
  },
  {
    key: 'hq rma',
    label: 'HQ RMA',
    value: 'HQ RMA'
  },
  {
    key: 'service center',
    label: 'SERVICE CENTER',
    value: 'SERVICE CENTER'
  }
];

export const rmaLocationOptions: RmaLocation[] = [
  {
    key: 'earnshaw',
    label: rmaLocations.EARNSHAW,
    value: rmaLocations.EARNSHAW,
    branch_id: PCWorthBranchesEnum.Earnshaw
  },
  {
    key: 'lpc',
    label: rmaLocations.LPC,
    value: rmaLocations.LPC,
    branch_id: PCWorthBranchesEnum.LPC
  },
  {
    key: 'experience',
    label: rmaLocations.EXPERIENCE,
    value: rmaLocations.EXPERIENCE,
    branch_id: PCWorthBranchesEnum.Experience
  },
  {
    key: 'eu',
    label: rmaLocations.EU,
    value: rmaLocations.EU
  },
  {
    key: 'service_center',
    label: rmaLocations.SERVICE_CENTER,
    value: rmaLocations.SERVICE_CENTER
  }
];

export const addRMAFields: RMAFormField[] = [
  {
    key: RMAField.PRODUCT_NAME,
    type: 'text',
    label: RMAFieldLabel.PRODUCT_NAME,
    disabled: true,
    grid: 'half'
  },
  {
    key: RMAField.SERIAL_NO,
    type: 'text',
    label: RMAFieldLabel.SERIAL_NO,
    disabled: true,
    grid: 'half'
  },
  {
    key: RMAField.CUSTOMER_NAME,
    type: 'text',
    label: RMAFieldLabel.CUSTOMER_NAME,
    required: true,
    grid: 'half'
  },
  {
    key: RMAField.CONTACT_NO,
    type: 'text',
    label: RMAFieldLabel.CONTACT_NO,
    grid: 'half'
  },
  {
    key: RMAField.STATUS,
    type: 'autocomplete',
    label: 'Status',
    options: rmaOptionsStatusesV2
  },
  {
    key: RMAField.TECH,
    type: 'text',
    label: RMAFieldLabel.TECH
  },
  // {
  //   key: RMAField.LOCATION,
  //   type: 'autocomplete',
  //   label: RMAFieldLabel.LOCATION,
  //   options: rmaLocationOptions
  // },
  {
    key: RMAField.REPORTED_PROBLEM,
    type: 'longText',
    label: RMAFieldLabel.REPORTED_PROBLEM
  },
  { key: RMAField.REMARKS, type: 'longText', label: RMAFieldLabel.REMARKS },
  {
    key: RMAField.INTERNAL_DIAGNOSIS,
    type: 'longText',
    label: RMAFieldLabel.INTERNAL_DIAGNOSIS
  },
  {
    key: RMAField.RMA_IMAGES,
    type: 'image',
    label: RMAFieldLabel.RMA_IMAGES
  }
];

export const rmaDetailsFields: RMAFormField[] = [
  {
    key: RMAField.PRODUCT_NAME,
    type: 'text',
    label: RMAFieldLabel.PRODUCT_NAME,
    disabled: true,
    grid: 'half'
  },
  {
    key: RMAField.SERIAL_NO,
    type: 'text',
    label: RMAFieldLabel.SERIAL_NO,
    disabled: true,
    grid: 'half'
  },
  {
    key: RMAField.SUPPLIER_NAME,
    type: 'text',
    label: RMAFieldLabel.SUPPLIER_NAME,
    disabled: true,
    grid: 'half'
  },
  {
    key: RMAField.TRANSACTION_NO,
    type: 'text',
    label: RMAFieldLabel.TRANSACTION_NO,
    disabled: true,
    grid: 'half'
  },
  {
    key: RMAField.CUSTOMER_NAME,
    type: 'text',
    label: RMAFieldLabel.CUSTOMER_NAME,
    required: true,
    grid: 'half'
  },
  {
    key: RMAField.CONTACT_NO,
    type: 'text',
    label: RMAFieldLabel.CONTACT_NO,
    grid: 'half'
  },
  {
    key: RMAField.STATUS,
    type: 'autocomplete',
    label: 'Status',
    options: rmaOptionsStatusesV2
  },
  // {
  //   key: RMAField.LOCATION,
  //   type: 'autocomplete',
  //   label: RMAFieldLabel.LOCATION,
  //   options: rmaLocationOptions
  // },
  {
    key: RMAField.TECH,
    type: 'text',
    label: RMAFieldLabel.TECH
  },
  {
    key: RMAField.REPORTED_PROBLEM,
    type: 'longText',
    label: RMAFieldLabel.REPORTED_PROBLEM
  },
  { key: RMAField.REMARKS, type: 'longText', label: RMAFieldLabel.REMARKS },
  {
    key: RMAField.INTERNAL_DIAGNOSIS,
    type: 'longText',
    label: RMAFieldLabel.INTERNAL_DIAGNOSIS
  },
  {
    key: 'show_diagnosis_history',
    type: 'button',
    label: 'Show Diagnosis History'
  },
  {
    key: RMAField.RMA_IMAGES,
    type: 'image',
    label: RMAFieldLabel.RMA_IMAGES
  }
];

export const rmaInventoryLocationOptions = [
  'End User',
  'STORE',
  'HQ RMA',
  'Service Center'
];

export const rmaInventoryStatusOptions = [
  'RMA (ONLINE)',
  'Void Warranty',
  'CLOSED',
  'RMA HQ',
  'Service Center',
  'Tested Good',
  'Replace Same Item',
  'Replace New Item',
  'REPAIRED',
  'Replace Refund New Item'
];
